exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".openPdfButton{width:150px !important;margin:10px !important}.checkerReview h3{padding-top:15px}.checkerReview .fa-minus-circle .fa-plus-circle{color:#a9a9a9}.checkerReview .padme{padding-top:15px}", ""]);

